import React, { Fragment } from "react";
import {
  Spin,
  Row,
  Col,
  Card as AntdCard,
  Statistic,
  Divider,
  Descriptions,
} from "antd";
import Card from "../../components/Card";
import { Bar, Line, Pie } from "react-chartjs-2";
import { User } from "../../helpers/shared-interfaces";
import { RouteComponentProps } from "react-router-dom";

interface ChartDataSet {
  label: string;
  backgroundColor?: string;
  borderColor?: string;
  data: number[];
}

interface ChartData {
  labels: string[];
  datasets: ChartDataSet[];
}

export interface ObjectLiteral {
  [key: string]: number[];
}

const barChartOptions = {
  showScale: true,
  pointDot: true,
  showLines: true,

  legend: {
    display: true,
    position: "bottom",
  },

  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          min: 0,
        },
      },
    ],
  },
};

const lineChartOptions = {
  showScale: true,
  pointDot: true,
  showLines: true,

  legend: {
    display: true,
    position: "bottom",
  },

  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          min: 0,
        },
      },
    ],
  },
};

const pieChartOptions = {
  title: "Tickets",

  legend: {
    display: true,
    position: "right",
  },
};

const summaryTicketingPieData = {
  labels: ["Resolved", "On Hold", "Breached", "Pending"],
  datasets: [
    {
      label: "Rainfall",
      backgroundColor: [
        "rgb(203, 172, 18)",
        "rgb(37, 191, 88)",
        "#2FDE00",
        "#00A6B4",
      ],
      hoverBackgroundColor: [
        "rgb(203, 172, 18)",
        "rgb(37, 191, 88)",
        "#175000",
        "#003350",
      ],
      data: [65, 59, 80, 81],
    },
  ],
};

const summaryInteractionsPieData = {
  labels: ["Open", "Closed", "Complaints"],
  datasets: [
    {
      label: "Rainfall",
      backgroundColor: ["#B21F00", "#C9DE00", "#2FDE00", "#00A6B4"],
      hoverBackgroundColor: ["#501800", "#4B5000", "#175000", "#003350"],
      data: [65, 59, 80, 81],
    },
  ],
};

const barData = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
  datasets: [
    {
      label: "Email",
      data: [33, 53, 85, 41, 44, 65],
      fill: true,
      backgroundColor: "rgb(203, 172, 18)",
      borderColor: "rgb(203, 172, 18)",
    },
    {
      label: "WhatsApp",
      data: [33, 25, 35, 51, 54, 76],
      fill: true,
      backgroundColor: "rgb(37, 191, 88)",
      borderColor: "rgb(37, 191, 88)",
    },
    {
      label: "Phone Call",
      data: [33, 25, 35, 51, 54, 76],
      fill: true,
      backgroundColor: "rgb(203, 18, 191)",
      borderColor: "rgb(203, 18, 191)",
    },
    {
      label: "WalkIn",
      data: [33, 25, 35, 51, 54, 76],
      fill: true,
      backgroundColor: "rgb(229, 54, 10)",
      borderColor: "rgb(229, 54, 10)",
    },
  ],
};
const lineData = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
  datasets: [
    {
      label: "Email",
      lineTension: 0.5,
      data: [33, 53, 85, 41, 44, 65],
      fill: false,
      backgroundColor: "rgb(203, 172, 18)",
      borderColor: "rgb(203, 172, 18)",
    },
    {
      label: "WhatsApp",
      lineTension: 0.5,
      data: [33, 20, 34, 51, 54, 76],
      fill: false,
      backgroundColor: "rgb(37, 191, 88)",
      borderColor: "rgb(37, 191, 88)",
    },
    {
      label: "Phone Call",
      lineTension: 0.5,
      data: [33, 25, 67, 51, 54, 32],
      fill: false,
      backgroundColor: "rgb(203, 18, 191)",
      borderColor: "rgb(203, 18, 191)",
    },
    {
      label: "WalkIn",
      lineTension: 0.5,
      data: [21, 34, 30, 51, 46, 63],
      fill: false,
      backgroundColor: "rgb(229, 54, 10)",
      borderColor: "rgb(229, 54, 10)",
    },
  ],
};

const pieData = {
  labels: ["Resolved", "On Hold", "Breached", "Pending"],
  datasets: [
    {
      label: "Rainfall",
      backgroundColor: ["#B21F00", "#C9DE00", "#2FDE00", "#00A6B4"],
      hoverBackgroundColor: ["#501800", "#4B5000", "#175000", "#003350"],
      data: [65, 59, 80, 81],
    },
  ],
};

const complaintsPieData = {
  labels: ["Within Sla", "Beyond Sla"],
  datasets: [
    {
      label: "Complaints",
      backgroundColor: ["#B21F00", "#C9DE00", "#2FDE00", "#00A6B4"],
      hoverBackgroundColor: ["#501800", "#4B5000", "#175000", "#003350"],
      data: [65, 59],
    },
  ],
};

export interface dashboard {
  department: string;
  component: typeof React.Component;
}

export interface dashboardSelectorProps {
  dashboards: dashboard[];
  user: User;
}

interface State {
  viewToRender: string;
  transformedData: ChartData;
  isLoading: boolean;
  wonOpportunitiesCount: number;
  inProgressOpportunitiesCount: number;
  prospectiveOpportunitiesCount: number;
}

interface Props extends RouteComponentProps {
  user: User;
}

export function SummaryView(): JSX.Element {
  return (
    <Fragment>
      <Row>
        <p>Dashboard Summary</p>
      </Row>

      <Row
        gutter={16}
        style={{
          marginBottom: "17px",
        }}
      >
        <Col span={12}>
          <AntdCard>
            <p>Ticketing</p>
            <Pie
              data={summaryTicketingPieData}
              width={20}
              height={5}
              options={pieChartOptions}
            />
          </AntdCard>
        </Col>
        <Col span={12}>
          <AntdCard>
            <p>Interactions</p>
            <Pie
              data={summaryInteractionsPieData}
              width={20}
              height={5}
              options={pieChartOptions}
            />
          </AntdCard>
        </Col>
      </Row>
      <Row
        gutter={16}
        style={{
          marginBottom: "17px",
        }}
      >
        <Col span={12}>
          <AntdCard>
            <p>Redemptions</p>
            <Pie
              data={complaintsPieData}
              width={20}
              height={5}
              options={pieChartOptions}
            />
          </AntdCard>
        </Col>
        <Col span={12}>
          <AntdCard>
            <p>Complaints</p>
            <Pie
              data={complaintsPieData}
              width={20}
              height={5}
              options={pieChartOptions}
            />
          </AntdCard>
        </Col>
      </Row>
    </Fragment>
  );
}

export function TicketingView(): JSX.Element {
  return (
    <Fragment>
      <Row>
        <p>Ticketing</p>
      </Row>
      <Row
        gutter={16}
        style={{
          marginBottom: "17px",
        }}
      >
        <Col span={5}>
          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <AntdCard>
                <Statistic title="Today's Tickets" value={120} />
              </AntdCard>
            </Col>
          </Row>
          <Row>
            <Col>
              <AntdCard>
                <Statistic title="Resolved Tickets" value={45} />
              </AntdCard>
            </Col>
          </Row>
        </Col>
        <Col span={18}>
          <AntdCard>
            <p>Ticketing Summary</p>
            <Pie
              data={pieData}
              width={20}
              height={5}
              options={pieChartOptions}
            />
          </AntdCard>
        </Col>
      </Row>
    </Fragment>
  );
}

export function InteractionsView(): JSX.Element {
  return (
    <Fragment>
      <Row>
        <p>Interactions</p>
      </Row>

      <Row
        gutter={16}
        style={{
          marginBottom: "17px",
        }}
      >
        <Col span={6}>
          <AntdCard>
            <Statistic
              title="Open / Closed Interactions"
              value={120}
              suffix="/230"
            />
          </AntdCard>
        </Col>
        <Col span={6}>
          <AntdCard>
            <Statistic title="Complaint Interactions" value={110} />
          </AntdCard>
        </Col>
        <Col span={6}>
          <AntdCard>
            <Statistic title="Processed within Sla" value={50} />
          </AntdCard>
        </Col>
        <Col span={6}>
          <AntdCard>
            <Statistic title="Processed beyond Sla" value={60} />
          </AntdCard>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <AntdCard>
            <p>Total Weekly Interactions</p>
            <Bar
              data={barData}
              width={20}
              height={5}
              options={barChartOptions}
            />
          </AntdCard>
        </Col>
        <Col span={12}>
          <AntdCard>
            <p>Interactions Trend</p>
            <Line
              data={lineData}
              width={20}
              height={5}
              options={lineChartOptions}
            />
          </AntdCard>
        </Col>
      </Row>
    </Fragment>
  );
}

export function ComplaintsView(): JSX.Element {
  return (
    <Fragment>
      <Row>
        <p>Complaints</p>
      </Row>

      <Row
        gutter={16}
        style={{
          marginBottom: "17px",
        }}
      >
        <Col span={6}>
          <AntdCard>
            <Descriptions title="Top 5 Complaints">
              <Descriptions.Item span={5}>
                1. Slow Redemptions
              </Descriptions.Item>
              <Descriptions.Item span={5}>
                2. Slow Payment Process
              </Descriptions.Item>
              <Descriptions.Item span={5}>
                3. Members Portal Inaccessible
              </Descriptions.Item>
              <Descriptions.Item span={5}>
                4. Missing Contributions
              </Descriptions.Item>
              <Descriptions.Item span={5}>
                5. Slow Members Portal
              </Descriptions.Item>
            </Descriptions>
          </AntdCard>
        </Col>
        <Col span={6}>
          <AntdCard>
            <Descriptions title="Top 10 Requests">
              <Descriptions.Item span={5}>
                1. Slow Redemptions
              </Descriptions.Item>
              <Descriptions.Item span={5}>
                2. Slow Payment Process
              </Descriptions.Item>
              <Descriptions.Item span={5}>
                3. Members Portal Inaccessible
              </Descriptions.Item>
              <Descriptions.Item span={5}>
                4. Missing Contributions
              </Descriptions.Item>
              <Descriptions.Item span={5}>
                5. Slow Members Portal
              </Descriptions.Item>
            </Descriptions>
          </AntdCard>
        </Col>
        <Col span={12}>
          <AntdCard>
            <p>Complaints</p>
            <Pie
              data={complaintsPieData}
              width={20}
              height={5}
              options={pieChartOptions}
            />
          </AntdCard>
        </Col>
      </Row>
    </Fragment>
  );
}

export function RedemptionsView(): JSX.Element {
  return (
    <Fragment>
      <Row>
        <p>Redemptions</p>
      </Row>

      <Row
        gutter={16}
        style={{
          marginBottom: "17px",
        }}
      >
        <Col span={8}>
          <AntdCard>
            <Statistic
              title="Received in Week/Month"
              value={120}
              suffix="/230"
            />
          </AntdCard>
        </Col>
        <Col span={8}>
          <AntdCard>
            <Statistic title="Processed within Sla" value={50} />
          </AntdCard>
        </Col>
        <Col span={8}>
          <AntdCard>
            <Statistic title="Processed beyond Sla" value={60} />
          </AntdCard>
        </Col>
      </Row>
    </Fragment>
  );
}

export default class CustomerServiceDashboard extends React.Component<
  Props,
  State
> {
  _isMounted = false;
  constructor(props: Readonly<Props>) {
    super(props);
    this.state = {
      isLoading: false,
      viewToRender: "All Actions",
      transformedData: { labels: [], datasets: [] },
      wonOpportunitiesCount: 0,
      inProgressOpportunitiesCount: 0,
      prospectiveOpportunitiesCount: 0,
    };
  }

  render(): JSX.Element | null | typeof React.Component | undefined {
    const { isLoading } = this.state;
    return (
      <Spin spinning={isLoading}>
        <Card>
          <Fragment>
            <SummaryView />
            <Divider />
            <TicketingView />
            <Divider />

            <InteractionsView />
            <Divider />
            <ComplaintsView />
            <Divider />
            <RedemptionsView />
            <Divider />
          </Fragment>
        </Card>
      </Spin>
    );
  }
}
